import React from 'react';
import { FaUser } from 'react-icons/fa';
import useAsyncAction from '../../../../../hooks/usePropertyAction';
import { addInterestedUser } from '../../../../../services/propertyService';
import { getUserData, withAuthCheck } from '../../../../../Utils/localStorageUtils';
import { useParams } from 'react-router-dom';
import useCustomNavigate from '../../../../../hooks/useCustomNavigate';

const ContactSection = () => {
  const { propertyId } = useParams();
  const userData = getUserData();
  const { goTo } = useCustomNavigate()
  const { execute, loading, data } = useAsyncAction(addInterestedUser); // ✅ Use the reusable hook


  const handleInterestClick = async (e) => {
    e.preventDefault();
    await withAuthCheck(async (userData) => {
      const response = await execute(propertyId, userData._id);

      if (response.success) {
        console.log("User is interested!");

      }
    })(goTo); // ✅ Pass `navigate`
  };

  return (
    <div className="bg-white px-3  sm:px-4 pt-5 sm:pt-7 pb-4 sm:pb-5 rounded-lg">
      {/* Horizontal Line */}
      <div className="border-t border-gray-300 mb-3  sm:mb-4"></div>

      {/* Buttons and Contact Info Section */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between space-y-3 sm:space-y-0">
        {/* Buttons Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
          {/* Contact Owner Button */}
          <button
            onClick={handleInterestClick}
            className="bg-[#2b463c] text-white font-medium px-4 py-2 rounded-full hover:bg-red-700"
            disabled={loading} // ✅ Disable while loading
          >
            {loading ? "Processing..." : data?.success ? "Already Interested" : "Contact Owner"}

          </button>
          {/* Get Phone Number Button */}
          {false && <button className="border border-red-600 text-red-600 font-medium px-4 py-2 rounded-full hover:bg-red-50">
            Get Phone No.
          </button>}
        </div>

        {/* Last Contact Info */}
        <div className="flex items-center space-x-2 text-gray-600 text-sm">
          <FaUser className="text-teal-500" />
          <span className="text-[#303030]">Last contact made 3 days ago</span>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
